import {createContext} from "react";
import {makeWithContext} from "../utils/context";

export const {Provider, Consumer} = createContext(null);
export const withContext = makeWithContext(Consumer);
